import { CSSProperties } from 'react';
import View from '../view';
import Text from '../text';
import { getGadgetLeagueInfo } from '../../utilities/helper';
import React from 'react';

interface Props {
  className?: string | undefined;
  containerStyle?: CSSProperties | undefined;
  titleStyle?: CSSProperties | undefined;
  titleClassName?: string | undefined;
  imageStyle?: CSSProperties | undefined;
  description?: string | undefined;
}
const GadgetLeague = ({
  containerStyle,
  titleStyle = {},
  titleClassName = '',
  // imageStyle = {},
  description = ''
}: Props) => {
  const { title = '', prizeURL = '' } = getGadgetLeagueInfo(description);
  return (
    <View
      style={{
        flexDirection: 'row',
        // justifyContent: 'center',
        alignItems: 'center',
        ...containerStyle
      }}>
      <img src={`${prizeURL}`} width={'7%'} />
      <Text className={`${titleClassName}`} style={titleStyle}>{`${title}`}</Text>
    </View>
  );
};
export default React.memo(GadgetLeague);
